(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("T1CSdk", [], factory);
	else if(typeof exports === 'object')
		exports["T1CSdk"] = factory();
	else
		root["T1CSdk"] = factory();
})(self, () => {
return 